import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ISalesInvoiceItemReportGetAllParams } from "@api/stores/salesInvoiceItemReport/types";

import type { IPathBaseParam } from "./path";
import type { ISalesInvoiceReportStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ISalesInvoiceReportStatsResponse>,
  IPathBaseParam,
  ISalesInvoiceItemReportGetAllParams
>("stores.salesInvoiceReport.stats");

export const stats = {
  ...getApis,
};
